import { useEffect } from "react";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonBackButton,
  IonButtons,
} from "@ionic/react";
import { FormattedMessage, useIntl } from "react-intl";
import PlanManagement from "../../../components/usage/management";

//Inferfaces
import { User, Settings } from "../../../interfaces";

const Language: React.FC<ILayoutProps> = (props: ILayoutProps) => {
  const { settings, user } = props;
  const intl = useIntl();

  useEffect(() => {
    props.onRequestSettings();
  }, []);

  return (
    <IonPage id="main-content">
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton
              defaultHref={`/settings`}
              text={intl.formatMessage({ id: "common.back" })}
            />
          </IonButtons>
          <IonTitle>
            <FormattedMessage id="payment.title" />
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen color="light">
        <PlanManagement settings={settings} isMobile={true} />
      </IonContent>
    </IonPage>
  );
};

interface ILayoutProps {
  onRequestSettings: Function;
  user: User;
  settings: Settings;
}

export default Language;
